import { useMemo } from 'react';
import { isPaidLicense } from '~/_shared/types/client/license.helpers';
import { MapTool } from '~/_shared/types/toolsAndFeatures/mapTools.types';
import { useTranslation } from '~/_shared/utils/hooks';
import {
  useUserDataSelector, useUserDataUsagesSelector, useUserLimitsSelector,
} from '~/store/userData/userData.selectors';

export const usePlacesErrors = () => {
  const [t] = useTranslation();
  const userData = useUserDataSelector();
  const placesLimit = useUserLimitsSelector().googlePlacesRequests;
  const placesUsage = useUserDataUsagesSelector().googlePlacesRequests;

  const overPlacesLimit = placesUsage >= placesLimit;

  const overLimitMessage = useMemo(() => ({
    title: t('Oh no, something went wrong'),
    message: isPaidLicense(userData.currentClient?.license.type)
      ? t('exceededLimit{{functionality}}.paid', { functionality: t(MapTool.Places) })
      : t('exceededLimit{{functionality}}.nonPaid', { functionality: t(MapTool.Places) }),
  }), [t, userData.currentClient?.license.type]);

  return {
    overPlacesLimit,
    overLimitMessage: overPlacesLimit ? overLimitMessage : null,
  };
};
